export default __webpack_public_path__ + "static/media/img8.51eff336.png";